import React from "react";
import Spinner from "@ui/Spinner";
import { colors, spacings } from "@ui/Theme";
import Button from "@ui/Button";
import tui from "@ui/i18n";
import t from "../../../../../../i18n";
import { css } from "@linaria/core";

interface P {
  onCancel: (() => void) | false;
  onEdit: (() => void) | false;
  onDuplication: ((e: React.FormEvent) => Promise<void>) | false;
  loading: boolean;
}

const ModalFooterLinkedEvent = ({ onCancel, onEdit, onDuplication, loading }: P) => (
  <>
    {(onCancel || onDuplication || onEdit) && (
      <div className={modalFooterLinkedEvent}>
        <Button
          variant="ghost"
          onClick={typeof onCancel === "function" ? onCancel : undefined}
          disabled={loading || onCancel === false}
          data-cy="cancel-button"
        >
          {tui("modal.cancel")}
        </Button>
        <div>
          <Button
            variant="secondary"
            onClick={typeof onDuplication === "function" ? onDuplication : undefined}
            disabled={loading || onDuplication === false}
            data-cy="duplication-button"
            leftIcon={loading ? <Spinner color={colors.hydrogen} /> : undefined}
          >
            {t("project.dashboard.header.modal.footer.duplicate_button")}
          </Button>
          <Button
            variant="primary"
            type={typeof onEdit === "boolean" ? "submit" : "button"}
            onClick={typeof onEdit === "function" ? onEdit : undefined}
            disabled={loading || onEdit === false}
            data-cy="edit-button"
          >
            {t("project.dashboard.header.modal.footer.edit_button")}
          </Button>
        </div>
      </div>
    )}
  </>
);

export default React.memo(ModalFooterLinkedEvent);

//#region Css
const modalFooterLinkedEvent = css`
  display: flex;
  justify-content: space-between;
  column-gap: 8px;
  background-color: ${colors.hydrogen};

  & > div > :not(button:first-child) {
    margin-left: ${spacings.xs};
  }

  button.centerButtons {
    margin: 0 calc(2%);
    max-width: 200px;
  }
`;
//#endregion Css
